var VCA = VCA || {};


VCA.ScrollTo = (function ($) {

    var ui = {};

    function init() {
        if (window.location.hash) {
            const hash = window.location.hash;
            const el = document.getElementById(hash);

            if (el && $(el).length) {
                $('html, body').animate({
                    //scrollTop: $(hash).offset().top
                }, 2500, 'swing');
            }
        }
    }

    return {
        init: init
    };

})(jQuery);

$(function () {
    VCA.ScrollTo.init();
});
